/**
 * A faixa de módulo encerrado — V5 da spec #408.
 *
 * Ela diz as duas metades: a leitura continua e a operação parou. Não tem botão de contratar
 * porque contratar não é ação do sistema — quem resolve é o comercial, e um botão que abre
 * nada seria pior que nenhum botão.
 *
 * Não é um `PrerequisiteBlock`: ali o caminho de saída existe e é do próprio usuário. Aqui o
 * que falta é comercial, e oferecer ação seria oferecer o que a pessoa não pode executar.
 */

import React from 'react';
import { Alert, AlertTitle, Typography } from '@mui/material';

import type { Modulo } from '../../types/manifesto';
import { NOME_DO_MODULO } from '../../utils/manifestoMenu';

export interface ModuleAccessBannerProps {
  modulo: Modulo;
}

export const ModuleAccessBanner: React.FC<ModuleAccessBannerProps> = ({ modulo }) => (
  <Alert severity='warning' sx={{ mb: 2 }}>
    <AlertTitle>O módulo {NOME_DO_MODULO[modulo]} não está mais contratado</AlertTitle>

    {/*
      As duas metades vão no mesmo parágrafo de propósito: separadas, a primeira frase virava
      um alívio isolado e a pessoa parava de ler antes de saber o que deixou de funcionar.
    */}
    <Typography variant='body2'>
      Consultar e imprimir continuam funcionando, inclusive os documentos já emitidos.
      Cadastrar, alterar e enviar estão bloqueados, inclusive o que já estava na fila. Para
      voltar a operar, fale com quem cuida do contrato na sua organização.
    </Typography>
  </Alert>
);

export default ModuleAccessBanner;
